import React from "react";
import { AppLayout } from "../layouts";
import { Header, SearchBars, Sides, Tabbles } from "../components";
import { Col, Container, Row } from "react-bootstrap";
import { LuMessagesSquare } from "react-icons/lu";
import { Commons } from "../utilities";
import { PiBinoculars } from "react-icons/pi";
import { useTranslation } from "react-i18next";

const ChatCommonPage = ({
  loginData,
  pageHeading,
  chatTableHeading,
  chatTableColumns,
  chatTableData,
  className,
  dateRange,
  searchValue,
  handleDateRangeChange,
  onSearchChange,
  onSearchClick,
}) => {
  const { t } = useTranslation();
  const formattedDate = Commons.formatDateWithOrdinal(new Date());

  const rightSide = (
    <Container fluid className={`exado-container1 ${className}`}>
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage pageHeading={pageHeading} />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <SearchBars.SearchBar
            className="search-bar"
            showDate={true}
            datepickermd={3}
            searchColmd={7}
            buttonColmd={2}
            searchGrpClassName="form-group1"
            searchPlaceholder={t("Search")}
            cDateRangePlaceholder={t("select_date")}
            cDateRangeClassname="custom-date-range-picker"
            buttonClassname="btn-solid-Aqua_Teal"
            buttonChildren={<PiBinoculars className="bionCularIcon" />}
            dateRange={dateRange}
            searchValue={searchValue}
            onDateRangeChange={handleDateRangeChange}
            onSearchChange={onSearchChange}
            onSearchClick={onSearchClick}
          />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <Tabbles.TableBlk
            headerIcon={<LuMessagesSquare className="header-Icn" />}
            heading={chatTableHeading}
            subHeading={
              <span>
                {t("Today")}, {formattedDate}
              </span>
            }
            columns={chatTableColumns}
            data={chatTableData}
            tabbleClassname="tabble"
          />
        </Col>
      </Row>
    </Container>
  );
  return (
    <AppLayout.AppLayoutOne
      leftSide={<Sides.LeftSides loginData={loginData} />}
      rightSide={rightSide}
    />
  );
};

export default ChatCommonPage;
